import { useState } from 'react'
import { Bell } from 'lucide-react'
import { useNotificationsStore } from '../store'
import { NotificationCenter } from './NotificationCenter'

interface NotificationBellProps {
  className?: string
}

export function NotificationBell({ className = '' }: NotificationBellProps) {
  const [isOpen, setIsOpen] = useState(false)
  const { unreadCount, activeChannel } = useNotificationsStore()

  return (
    <>
      <button
        className={`notification-bell ${className}`}
        onClick={() => setIsOpen(true)}
        aria-label={`Notificaciones${unreadCount > 0 ? ` (${unreadCount} sin leer)` : ''}`}
      >
        <Bell size={20} />
        {unreadCount > 0 && (
          <span className="notification-bell__badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
        {activeChannel === 'websocket' && (
          <span className="notification-bell__indicator" />
        )}

        <style>{`
          .notification-bell {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            padding: 0;
            border: none;
            border-radius: var(--radius-md);
            background: transparent;
            color: var(--color-text-secondary);
            cursor: pointer;
            transition: all 0.2s;
          }

          .notification-bell:hover {
            background: var(--color-bg-secondary);
            color: var(--color-text-primary);
          }

          .notification-bell__badge {
            position: absolute;
            top: 4px;
            right: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            border-radius: var(--radius-full);
            background: var(--color-danger);
            color: white;
            font-size: 10px;
            font-weight: 600;
            line-height: 1;
          }

          .notification-bell__indicator {
            position: absolute;
            bottom: 6px;
            right: 6px;
            width: 6px;
            height: 6px;
            border-radius: var(--radius-full);
            background: var(--color-success);
            border: 1px solid var(--color-bg-primary);
          }
        `}</style>
      </button>

      <NotificationCenter isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}
